import { EventCard } from "@features/events/EventCard"
import { EventCardFragment } from "@generated-types"
import { defineView } from "eddev/views"

function dateSort(event: EventCardFragment) {
  const dates = [
    event.info?.tessProductionSeason?.firstPerformanceDate,
    event.info?.tessProductionSeason?.lastPerformanceDate,
  ]
    .filter(Boolean)
    .map((date) => new Date(date!))
    .filter((date) => !isNaN(date.getTime()))
  const avg = dates.reduce((sum, date) => sum + date.getTime(), 0) / dates.length
  return avg
}

export default defineView("front-page", (props) => {
  const events =
    props.events?.nodes.toSorted((a, b) => {
      return dateSort(a) - dateSort(b)
    }) ?? []
  return (
    <div className="grid-auto">
      <div className="col-span-12 py-6">
        <h1 className="type-title-xxl">What's On</h1>
      </div>
      <ul className="col-span-12 grid-auto gap-y-grid-gutter">
        {events.map((event) => (
          <li key={event.id} className="col-span-12 sm:col-span-6 md:col-span-3">
            <EventCard event={event} />
          </li>
        ))}
      </ul>
    </div>
  )
})
